module.exports = __webpack_public_path__ + "7d068ea22cd0c100df48667009933f84.png";